
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","viewBox":"0 0 384 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m368 32h4c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12h-360c-6.627 0-12 5.373-12 12v8c0 6.627 5.373 12 12 12h4c0 91.821 44.108 193.657 129.646 224-85.814 30.441-129.646 132.477-129.646 224h-4c-6.627 0-12 5.373-12 12v8c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12h-4c0-91.821-44.108-193.657-129.646-224 85.814-30.441 129.646-132.477 129.646-224zm-320 0h288c0 110.457-64.471 200-144 200s-144-89.543-144-200zm288 448h-288c0-110.457 64.471-200 144-200s144 89.543 144 200z"}})])
          )
        }
      }
    